var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2738_5992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6607 6.02683C12.6741 2.75253 10.0328 0.102539 6.76954 0.102539C3.54646 0.102539 0.891757 2.72596 0.871696 5.9272C0.851636 9.22143 3.4729 11.8847 6.75617 11.898C9.99263 11.9179 12.6473 9.27456 12.6607 6.02683ZM13.316 6.29913C13.3628 6.67106 13.403 7.3485 13.5367 8.00602C13.7707 9.15501 14.1586 10.2442 15.0814 11.0611C15.7902 11.6921 16.7932 11.7187 17.4686 11.0545C17.823 10.7025 18.164 10.2907 18.3847 9.84573C19.3543 7.87319 19.4212 5.80101 18.9531 3.69563C18.7257 2.67283 18.3245 1.71644 17.5154 0.979227C16.8133 0.341636 15.8303 0.27522 15.1549 0.90617C14.7871 1.24489 14.4528 1.65667 14.2121 2.09501C13.5367 3.29714 13.3495 4.6321 13.316 6.29913ZM19.7889 5.83422C19.916 7.0762 19.9962 8.1787 20.15 9.26792C20.2169 9.73947 20.3774 10.211 20.5713 10.656C20.7452 11.0678 21.0728 11.0678 21.2667 10.6626C21.4205 10.3571 21.5409 10.0317 21.6078 9.69962C22.0692 7.38835 22.0826 5.0638 21.6947 2.73925C21.6145 2.27434 21.4607 1.82271 21.2935 1.37772C21.24 1.23825 21.0528 1.05893 20.9257 1.05893C20.7987 1.05893 20.6248 1.23161 20.5512 1.37108C20.4175 1.62346 20.3038 1.90241 20.2637 2.18135C20.0832 3.43661 19.9294 4.69851 19.7889 5.83422Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2738_5992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.0972,
    height: 11.7954,
    fill: "#BBBBBB",
    transform: "translate(0.87207 0.102539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ecc5f27a1837dca61875fb72721b0dd9.svg";
export { ForwardRef as ReactComponent };